import { themedUseStyletron } from '../../../theme/customTheme'
import { IEHeat } from './types'
import { Icon } from "./Icon";

export function SmallPanel(props: IEHeat) {
    const [css, theme] = themedUseStyletron();

    const color = props.isOn ? theme.colors.negative400 : theme.appColors.aggregate.off;
    return (


        <Icon color={theme.appColors.aggregate.off} color2={color} width='60px'></Icon>
  
    );
}

